import React from 'react';
import { BaasicDropzoneTemplate } from 'themes/components';

function BaasicDropzone(props) {
	return <BaasicDropzoneTemplate {...props} />;
}

export default BaasicDropzone;
